import graphql from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query licenses_Query($kinds: [LearnableKind!]!) {
		...licenseSettings_QueryFragment
		...licensesTab_LicensesTabFragment @arguments(kinds: $kinds)
		...manageLicensesTab_ManageLicensesTabFragment @arguments(kinds: $kinds)
	}
`;
